/* ===========================================================================
   ROVE NEXT - THE BUY BOX POSTS THE VARIANT THE SHOPPER ACTUALLY CHOSE.
   28 August 2026.

   THE BUG THIS CLOSES

   sections/rn-buybox.liquid renders the cart form's variant field once:

       <input type="hidden" name="id" value="{{ cur_variant.id }}">

   where cur_variant is product.selected_or_first_available_variant - the
   FIRST variant. The only code in that file that ever rewrites the field
   sits inside its `cfg_on` branch, which is true only for config_mode
   'grid'. Reya is the only product in grid mode.

   So on Diane, Ophelia, Sphere, Alba and the Storage Drawers, clicking a
   size or a colourway rebuilt the gallery and nothing else. The form still
   carried variant one, and Add to Cart posts a VARIANT ID, so:

       Ophelia   pick King / Sage   -> Queen / Oat  in the cart
       Alba      pick King C$621    -> Queen, charged C$462
       Drawers   pick King C$595    -> Queen, charged C$495
       Diane     pick Solstice      -> Moonstone shipped
       Sphere    pick Black         -> Moonstone shipped

   This does for the ordinary size/swatch PDPs exactly what the grid
   controller already does for Reya: resolve the variant from what is
   selected, write it into every cart form, and move the price with it.

   WHY IT IS A SEPARATE ASSET AND NOT AN EDIT TO THE SECTION
   Sharon's standing rule, carried over from rn-pdp-config.js:
   rn-buybox.liquid is 155KB and shared by five PDPs. The API rewrites whole
   files, so a thirty-line change means retransmitting all of it with every
   product page riding on the outcome.

   NOTHING HERE IS GUESSED. The price format is read back off the price the
   theme already rendered, so it cannot disagree with Shopify's `money`
   filter. The monthly figure repeats the section's own arithmetic. A token
   that is not a real option value on this product is dropped rather than
   matched, which is what lets the drawers' "Dark Truffle" finish swatch and
   Diane's absent size row both fall through to the correct variant.
   =========================================================================== */
(function () {
  var bb = document.querySelector('[id^="rn-bb-"]');
  if (!bb) return;

  /* Reya. The grid controller in the section owns the variant field there,
     and running two writers over one input is how they start disagreeing. */
  if (bb.querySelector('[data-bb-cfgjson]')) return;

  var handle = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
  if (!handle) return;

  var idInputs = [].slice.call(bb.querySelectorAll('[data-bb-form] input[name="id"]'));
  if (!idInputs.length) return;

  var priceEl    = bb.querySelector('.bb-price');
  var pricesWrap = bb.querySelector('.bb-prices');
  var stickyBox  = bb.querySelector('.bb-sticky-price');
  var finLead    = bb.querySelector('.bb-finlead');
  var finNote    = bb.querySelector('.bb-fin');
  var atcBtns    = [].slice.call(bb.querySelectorAll('.bb-atc,.bb-sticky-atc'));

  /* ---- money, in whatever shape Liquid already used --------------------
     The section printed the first variant through `money`. Rather than
     hardcode a currency or a decimal convention, the prefix and the decimal
     places are read back off that string, so every figure this file writes
     is formatted identically to the one it replaces. */
  var PREFIX = 'C$';
  var DECS = 0;
  (function learnFormat() {
    var t = priceEl ? (priceEl.textContent || '').trim() : '';
    var firstDigit = t.search(/\d/);
    if (firstDigit < 0) return;
    PREFIX = t.slice(0, firstDigit);
    DECS = /[.,]\d{2}$/.test(t) ? 2 : 0;
  })();

  function fmt(cents, decimals) {
    var d = typeof decimals === 'number' ? decimals : DECS;
    var n = (cents || 0) / 100;
    return PREFIX + n.toLocaleString('en-CA', {
      minimumFractionDigits: d, maximumFractionDigits: d
    });
  }

  /* The section's own arithmetic: price over twelve, rounded to WHOLE
     dollars, printed without trailing zeros. Sharon's format is
     "Starting at C$426/mo", not C$425.58. */
  function monthly(cents) {
    if (!cents || cents <= 0) return '';
    return fmt(Math.round(cents / 12 / 100) * 100, 0);
  }

  /* ---- what the shopper has selected ----------------------------------
     Only the SIZE group and the fabric swatches. [data-group="alba"] and
     [data-group="plan"] are separate purchases, not axes of this variant. */
  function selected() {
    var out = [];
    var sz = bb.querySelector('.bb-opts[data-group="size"] .bb-opt.on b');
    if (sz && sz.textContent) out.push(sz.textContent.trim());
    var sw = bb.querySelector('.bb-sw.on');
    var nm = sw && sw.getAttribute('data-name');
    if (nm) out.push(nm.trim());
    return out;
  }

  var variants = null;
  var optionValues = {};   /* every real option value on this product */
  var baseFinLead = finLead ? finLead.innerHTML : '';
  var baseFinNote = finNote ? finNote.innerHTML : '';
  var baseMonthly = '';

  /* ---- pre-order, per variant, 24 September 2026 ------------------------
     THE BUG THIS CLOSES. This used to "learn" the button's enabled-state
     text once, from whichever variant the server happened to render, and
     reuse that exact string for every variant afterward. A page that loads
     on a pre-order colourway learned "PRE-ORDER" and then showed PRE-ORDER
     for every colourway for the rest of the visit, in-stock ones included;
     a page that loads on an in-stock colourway did the same in reverse.
     Confirmed live on Diane: refresh on a pre-order swatch and every swatch
     reads PRE-ORDER; refresh on Moonstone (in_stock) and every swatch reads
     ADD TO CART.

     window.RN_NOTIFY already carries each variant's real pre-order mode --
     it is rendered by snippets/rn-preorder-cap.liquid from the same
     v.metafields.preorder.mode this section itself reads, for the notify-me
     form -- so the state can be looked up instead of remembered. Reused
     rather than duplicated for that reason: one source of truth. */
  var poMap = {};
  (function readPreorderMap() {
    var n = window.RN_NOTIFY;
    if (!n || !Array.isArray(n.variants)) return;
    /* Decided by real stock, never preorder.mode -- same rule as po_on in
       sections/rn-buybox.liquid: units on the shelf ship now (Add to Cart);
       none on hand with a container date is a pre-order, and an untracked
       count (stock null) counts as none on hand. This is quantity 1;
       assets/rn-pdp-qty.js re-decides it for the quantity actually chosen. */
    n.variants.forEach(function (v) {
      poMap[String(v.id)] = !!v.eta && !(v.stock > 0);
    });
  })();

  /* window.RN_BB_LABELS is rendered by rn-buybox.liquid from the same
     atc_label/po_label/sold_out_label settings the server-rendered button
     already used, so the real text is available even for a state (pre-order
     vs plain) the initial paint never showed. Missing only if this asset
     shipped ahead of that section change -- fall back to whatever the
     button already says rather than break. */
  var LABELS = window.RN_BB_LABELS || {};
  var firstBtn = atcBtns[0];
  var FALLBACK = firstBtn ? (firstBtn.textContent || '').trim() : '';
  var ATC_TXT  = LABELS.atc  || FALLBACK;
  var PO_TXT   = LABELS.po   || FALLBACK;
  var SOLD_TXT = LABELS.sold || FALLBACK;

  function lower(s) { return String(s == null ? '' : s).toLowerCase().trim(); }

  function pick() {
    if (!variants || !variants.length) return null;
    var want = selected().filter(function (t) { return optionValues[lower(t)]; });
    for (var i = 0; i < variants.length; i++) {
      var opts = (variants[i].options || []).map(lower);
      var ok = true;
      for (var j = 0; j < want.length; j++) {
        if (opts.indexOf(lower(want[j])) < 0) { ok = false; break; }
      }
      if (ok) return variants[i];
    }
    return null;
  }

  function setStruck(container, el, cents, make) {
    if (cents) {
      if (!el && container) { el = make(); }
      if (el) { el.textContent = fmt(cents); el.hidden = false; el.style.display = ''; }
    } else if (el) {
      el.hidden = true; el.style.display = 'none';
    }
    return el;
  }

  function apply(v) {
    if (!v) return;

    idInputs.forEach(function (inp) { inp.value = v.id; });

    var onSale = !!(v.compare_at_price && v.compare_at_price > v.price);

    if (priceEl && v.price > 0) {
      priceEl.textContent = fmt(v.price);
      priceEl.classList.toggle('is-sale', onSale);
    }
    if (pricesWrap) {
      setStruck(pricesWrap, pricesWrap.querySelector('.bb-was'),
        onSale ? v.compare_at_price : 0,
        function () {
          var s = document.createElement('s');
          s.className = 'bb-was';
          pricesWrap.insertBefore(s, priceEl || pricesWrap.firstChild);
          return s;
        });
    }

    if (stickyBox) {
      var em = stickyBox.querySelector('em');
      if (em && v.price > 0) {
        em.textContent = fmt(v.price);
        em.classList.toggle('is-sale', onSale);
      }
      setStruck(stickyBox, stickyBox.querySelector('s'),
        onSale ? v.compare_at_price : 0,
        function () {
          var s = document.createElement('s');
          stickyBox.insertBefore(s, stickyBox.firstChild);
          return s;
        });
    }

    /* The finance lines were rendered with {mo} already substituted, so the
       only safe edit is to swap the figure that is in there for the new one.
       With no starting figure to swap, they are left untouched. */
    var mo = monthly(v.price);
    if (baseMonthly && mo) {
      if (finLead) finLead.innerHTML = baseFinLead.split(baseMonthly).join(mo);
      if (finNote) finNote.innerHTML = baseFinNote.split(baseMonthly).join(mo);
    }

    var isPreorder = !!poMap[String(v.id)];
    atcBtns.forEach(function (b) {
      b.disabled = !v.available;
      var want = v.available ? (isPreorder ? PO_TXT : ATC_TXT) : SOLD_TXT;
      if (want && b.textContent.trim() !== want) b.textContent = want;
    });

    /* Tells assets/rn-pdp-qty.js which variant is now live, so it can look up
       real stock and pre-order remaining (window.RN_NOTIFY, rendered by
       snippets/rn-preorder-cap.liquid) and move the quantity cap and stock
       line to match. Kept as a dispatch rather than a direct call so this
       file does not need to know that script exists. */
    document.dispatchEvent(new CustomEvent('rn:bb-variant', { detail: { id: v.id } }));

    /* Keep the address honest, so a reload or a shared link lands on the
       same variant - Shopify reads ?variant= into
       selected_or_first_available_variant, which is what the page renders
       from in the first place. */
    if (window.history && history.replaceState) {
      try {
        var u = new URL(location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u.toString());
      } catch (e) { /* a URL this old browser cannot parse is not worth failing over */ }
    }
  }

  function sync() { apply(pick()); }

  fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (p) {
      if (!p || !p.variants || !p.variants.length) return;
      variants = p.variants;
      variants.forEach(function (v) {
        (v.options || []).forEach(function (o) { optionValues[lower(o)] = true; });
      });

      /* The figure currently printed in the finance lines belongs to the
         variant the page rendered with, which is variant one unless the URL
         carried ?variant=. Resolve it the same way the page did. */
      var initial = null;
      var q = (location.search.match(/[?&]variant=(\d+)/) || [])[1];
      if (q) {
        initial = variants.filter(function (v) { return String(v.id) === q; })[0] || null;
      }
      if (!initial) initial = variants[0];
      baseMonthly = monthly(initial.price);

      /* THE FIRST RESOLUTION MUST NOT GO THROUGH pick(). 25 September 2026.

         pick() resolves "the selected variant" from selected(), which reads
         whichever swatch currently carries .on. On every click after this
         one that is correct — the clicked swatch's .on state IS the choice.
         On the very FIRST call it is not: the section sets that class from
         active_sw, a completely different piece of Liquid that picks the
         first swatch block with gallery images so the combined photo strip
         has somewhere to start, with no reference to cur_variant or
         ?variant= at all.

         The two can disagree. A shopper arriving on ?variant=<Oat's id> can
         load the page with Moonstone's swatch marked .on, if Moonstone
         happens to be the first block with photos — and pick() would then
         resolve to Moonstone: wrong price, wrong pre-order state, wrong
         stock line, all on the variant the URL and the page's own hidden id
         field already agree is Oat. Confirmed as the cause of stock/pre-order
         figures matching whatever variant was open before this one, not the
         one just navigated to.

         The hidden id input already carries the answer Shopify itself
         computed (cur_variant.id, which does honour ?variant=), so the first
         apply() uses that directly instead. */
      var serverId = idInputs[0] && idInputs[0].value;
      var serverVariant = serverId
        ? variants.filter(function (v) { return String(v.id) === String(serverId); })[0]
        : null;
      apply(serverVariant || pick() || initial);
    })
    .catch(function () { /* leave the page exactly as rendered rather than guessing */ });

  /* The section's own handlers set .on during their click pass, so this runs
     after them. Same delayed-resync idiom rn-pdp-addon.js already uses. */
  bb.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.bb-opt, .bb-sw')) {
      setTimeout(sync, 60);
    }
  }, true);
})();
